import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CommonLayoutModule } from "../../../common-layout/common-layout.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EnvironmentViewSingleComponent } from "./environment-view-single/environment-view-single.component";
import { ServerdetailspopupComponent } from "./serverdetailspopup/serverdetailspopup.component";
import { AddServersComponent } from './add-servers/add-servers.component';
import { ReviewServerPurchaseComponent } from "./review-server-purchase/review-server-purchase.component";
import { EditEnvironmentComponent } from "./edit-environment/edit-environment.component";
import { ServerConnectionDetailsPopupComponent } from './environment-popups/server-connection-details-popup/server-connection-details-popup.component';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MatTableModule } from "@angular/material/table";
import { MatCheckboxModule } from "@angular/material/checkbox";
@NgModule({
    declarations: [
        EditEnvironmentComponent,
        AddServersComponent,
        ReviewServerPurchaseComponent,
        EnvironmentViewSingleComponent,
        ServerConnectionDetailsPopupComponent,
        ServerdetailspopupComponent
    ],
    
    imports: [
        MatTableModule,
        MatCheckboxModule,
        FontAwesomeModule,
        CommonModule,
        CommonLayoutModule,
        FormsModule,
        ReactiveFormsModule]

})
export class EnvironmentsViewSingleModule { }

